import { useEffect, useRef, useState } from "react";
import Billing from "../ClinicPetDetails/Billing/Billing";

/**
 * Clinic Payments → Estimates editor only.
 * Renders Billing for estimate edit; no empty landing.
 * Exit (Save As Draft / Discard) returns to origin tab without touching other flows.
 */
const Estimates = ({
  selectedPayment,
  setSelecetdPayment,
  setActiveTab,
  setSelectedPaymentTab,
}) => {
  const [selectedBill, setSelectedBill] = useState(null);
  const [editBill, setEditBill] = useState(false);
  const exitingRef = useRef(false);
  const returnTabRef = useRef(
    selectedPayment?.returnTab || "Payments",
  );

  useEffect(() => {
    if (selectedPayment?.returnTab) {
      returnTabRef.current = selectedPayment.returnTab;
    }
  }, [selectedPayment?.returnTab]);

  const navigateBack = () => {
    if (exitingRef.current) return;
    exitingRef.current = true;
    const returnTab = returnTabRef.current || "Payments";
    setEditBill(false);
    setSelectedBill(null);
    setSelecetdPayment?.(null);
    // Only switch Payments sub-tab when returning to Payments list
    if (returnTab === "Payments") {
      setSelectedPaymentTab?.("Estimates");
    }
    setActiveTab?.(returnTab);
  };

  useEffect(() => {
    if (exitingRef.current) return;

    if (selectedPayment?.paymentId && selectedPayment?.estimate) {
      setSelectedBill({ paymentId: selectedPayment.paymentId });
      setEditBill(true);
      return;
    }

    // Opened Estimates route with no estimate payload — leave (no empty UI).
    // Do not re-run after an intentional exit (guarded by exitingRef).
    navigateBack();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPayment?.paymentId, selectedPayment?.estimate]);

  const handleEditBill = (next) => {
    // Billing Save As Draft / Discard call setEditBill(false) — exit estimate only.
    // Does not change Billing.js behavior for appointment / other callers.
    if (!next) {
      navigateBack();
      return;
    }
    setEditBill(next);
  };

  if (editBill && selectedBill?.paymentId) {
    return (
      <div>
        <Billing
          bill={selectedBill}
          setSelectedBill={setSelectedBill}
          setEditBill={handleEditBill}
        />
      </div>
    );
  }

  return null;
};

export default Estimates;
